import { PrivateInterceptor } from "../../interceptors/PrivateInterceptor";

export const getPurchaseOrders = async () => {
    
    const result = await PrivateInterceptor(`Base/Compras/purchaseOrders`, 'GET');
    return result;

}

export const getPurchaseOrder = async(PurchaseOrder) =>{
    const result = await PrivateInterceptor(`Base/Compras/purchaseOrders/${PurchaseOrder}`, 'GET');
    return result;
}

export const getDetallesPurchaseOrder = async(IdPurchaseOrder) =>{
    const result = await PrivateInterceptor(`Base/Compras/purchaseOrders/Detalles/${IdPurchaseOrder}`, 'GET');
    return result;
}

export const getPurchasesOrdersProveedor = async(IdProveedor) =>{
    const result = await PrivateInterceptor(`Base/Compras/purchaseOrders/Proveedor/${IdProveedor}`, 'GET');
    return result;
}

export const getPurchasesOrdersProveedorBalance = async(IdProveedor) =>{
    const result = await PrivateInterceptor(`Base/Compras/purchaseOrders/OrdenesBalance/${IdProveedor}`, 'GET');
    return result;
}

export const getBalancePurchaseDetail = async(IdDetalle, IdPOD) =>{
    const result = await PrivateInterceptor(`Base/Compras/purchaseOrders/BalanceOrdenDetail`, 'POST', {IdDetalle: IdDetalle, IdPOD: IdPOD});
    return result;
}


export const getAllPurchaseOrder = async() =>{
    const result = await PrivateInterceptor(`Base/Compras/purchaseOrders/AllPOS/PO`, 'GET');
    return result;
}

export const getBalancePurchaseDetails = async(IdPurchaseOrder)=>{
    const result = await PrivateInterceptor(`Base/Compras/purchaseOrders/BalancePurchaseDetails/${IdPurchaseOrder}`, 'GET');
    return result;
}


